import { useState, useEffect } from 'react';
import { Text, Popover } from '@bigcommerce/big-design';
import { ContentCopyIcon } from '@bigcommerce/big-design-icons';

export default function CopyableLink({ link, label }) {
	const [isOpen, setIsOpen] = useState(false);
	const [ref, setRef] = useState(null);

	useEffect(() => {
		let timeoutId;
		if (isOpen) {
			timeoutId = setTimeout(() => {
				setIsOpen(false);
			}, 2000);
		}
		return () => {
			clearTimeout(timeoutId);
		};
	}, [isOpen]);

	if (!link) {
		return label ? <Text>{label}: N/A</Text> : <Text>N/A</Text>;
	}

	const shouldShowLabel = typeof label === 'string' && label.length > 0;
	const iconTitle = shouldShowLabel ? `Copy ${label}` : 'Copy link';

	return (
		<>
			<span
				onClick={(e) => {
					e.stopPropagation();
					navigator.clipboard.writeText(link);
					setIsOpen(true);
				}}
				ref={setRef}
				style={{ cursor: 'pointer', display: 'inline' }}
			>
				{shouldShowLabel ? <Text as="span">{label}</Text> : null}
				<ContentCopyIcon size="medium" title={iconTitle} />
			</span>
			<Popover
				anchorElement={ref}
				isOpen={isOpen}
				label="Copied to clipboard"
				placement="top"
				onClose={() => setIsOpen(false)}
			>
				<Text>Link copied to clipboard</Text>
			</Popover>
		</>
	);
}


